import { RefObject, useCallback, useEffect, useState } from 'react'
import animateScrollTo from 'animated-scroll-to'
import { useDebounceCallback } from '@react-hook/debounce'

/**
 * useGoToTop
 * author: soojin.oh
 */

const SCROLL_OFFSET_FOR_OPEN = 100

// hook
// modal에서는 scrollTarget 을 넘겨주어야한다.
const useGoToTop = (scrollTarget?: RefObject<HTMLDivElement>) => {
  const [isFabOpen, setFabOpen] = useState(false)

  // throttle 의 경우 애니메이션 도중 GC 발생하여 애니메이션이 끊김.
  // throttle 에서 함수를 계속 생성하는것 같은데 사용에 유의
  const onScroll = useDebounceCallback(
    useCallback(() => {
      if (!scrollTarget?.current) {
        setFabOpen((window.pageYOffset || window.scrollY) > SCROLL_OFFSET_FOR_OPEN)
      } else {
        setFabOpen((scrollTarget.current?.scrollTop || 0) > SCROLL_OFFSET_FOR_OPEN)
      }
    }, [scrollTarget])
  )
  const onClick = useCallback(() => {
    if (!scrollTarget) {
      animateScrollTo(0)
    } else {
      animateScrollTo(0, { elementToScroll: scrollTarget.current! })
    }
  }, [scrollTarget])

  useEffect(() => {
    if (!scrollTarget) {
      window.addEventListener('scroll', onScroll)
      return () => window.removeEventListener('scroll', onScroll)
    } else {
      scrollTarget.current?.addEventListener('scroll', onScroll)
      return () => scrollTarget.current?.removeEventListener('scroll', onScroll)
    }
  }, [scrollTarget, onScroll])

  return {
    isFabOpen,
    setFabOpen,
    onClick,
  }
}
export default useGoToTop
